import { axiosInstance } from "../apiRequest";
import { apiRoutes } from "../Constants/ApiRoutes";

/** Normalize to array; accept single object or alternate keys. */
function normalizeSources(data) {
    const raw = data.sources ?? data.source ?? data.references ?? data.source_list ?? [];
    if (Array.isArray(raw)) return raw;
    if (raw && typeof raw === "object" && !Array.isArray(raw)) return [raw];
    return [];
}

/** Build source entry from a search result (fullPath or categorySlug/slug). */
function searchResultToSource(item, index) {
    const url = item.fullPath
        ? (item.fullPath.startsWith("/") ? item.fullPath : `/${item.fullPath}`)
        : item.categorySlug
          ? `/${item.categorySlug}/${item.slug || ""}`
          : item.slug
            ? `/${item.slug}`
            : null;
    return {
        id: item.articleId ?? item.id ?? index,
        kb_id: item.articleId ?? item.kb_id,
        title: item.title ?? item.name,
        url: url || item.url,
    };
}

/**
 * AI search: single request via POST v1/article/search (Bearer token).
 * Sources are normalized; if API returns none, they are derived from search_results.
 * @param {{ query: string }} params
 * @returns {Promise<{ content: string, sources: any[], search_results: any[] }>}
 */
export async function getAiSearchResponse({ query = "" }) {
    const searchTerm = (query || "").trim();
    const res = await axiosInstance.post(apiRoutes.kbArticleSearch, { searchTerm });
    let data = res?.data?.data ?? res?.data ?? res;
    if (Array.isArray(data)) data = data[0] ?? {};
    const searchResults = Array.isArray(data.search_results)
        ? data.search_results
        : [];
    let sources = normalizeSources(data);
    if (sources.length === 0 && searchResults.length > 0) {
        sources = searchResults.map((item, i) => searchResultToSource(item, i));
    }
    return {
        content: data.content ?? "",
        sources,
        search_results: searchResults,
    };
}
